import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'

import styles from './FinalizeTaskDialog.module.sass'

const FinalizeTaskDialog = (props) => {
	const { i18n } = useGlobal()
	const { submitting, dismiss, submissionType } = props

	const submissionTypes = {
		approve: {
			submitting: i18n`Approving`,
			success: i18n`Successfully approved`,
		},
		resolve: {
			submitting: i18n`Sending your request`,
			success: i18n`Requisition sent successfully`,
		},
		postpone: {
			submitting: i18n`Postponing`,
			success: i18n`Successfully postponed`,
		},
		refuse: {
			submitting: i18n`Refusing`,
			success: i18n`Successfully refused`,
		},
		forward: {
			submitting: i18n`Forwarding`,
			success: i18n`Successfully forwarded`,
		},
		nullify: {
			submitting: i18n`Nullifying`,
			success: i18n`Successfully nullified`,
		},
	}

	return (
		<div className={styles['submitting-indicator']}>
			{submitting === 'submitting' && (
				<div>
					<Icon
						className={`${styles['action-icon']} ${styles['--submitting']}`}
						name='submit'
					/>
					<small>{submissionTypes[submissionType]?.submitting}</small>
				</div>
			)}
			{submitting === 'success' && (
				<div>
					<Icon className={styles['action-icon']} name='success' />
					<small>{submissionTypes[submissionType]?.success}</small>
					<br />
					<HStack className={styles['menu']} gap='xsmall'>
						<ActionButton
							className={styles['menu-button-secondary']}
							secondary
							onClick={() => {
								dismiss(true)
							}}
						>
							{i18n`Close`}
						</ActionButton>

						<ActionButton
							className={styles['menu-button-primary']}
							primary
							onClick={() => {
								dismiss(true, true)
							}}
						>{i18n`Open Next`}</ActionButton>
					</HStack>
				</div>
			)}
		</div>
	)
}

export default FinalizeTaskDialog
